//NEW STYPEPARAMS METHOD
var INFO_LAYOUT = {
    NO_BACKGROUND: 'NO_BACKGROUND',
    ATTACHED_BACKGROUND: 'ATTACHED_BACKGROUND',
    SEPARATED_BACKGROUND: 'SEPARATED_BACKGROUND',
    DONT_SHOW: 'DONT_SHOW',
};
export default INFO_LAYOUT;
//# sourceMappingURL=layoutParams_info_layout.js.map